// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
// @flow
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { get, includes } from 'lodash';

import { Header, CookiePolicyBanner, GlobalHeader, NonAuthHeader } from '../../components';
import { BreadcrumbsForPages } from '../../pageComponents';
import theme from './index.theme';
import {
  getNewLandingPage,
} from '../../reducers/portalConfig';
import {
  NO_AUTH_NO_HEADER_PAGES,
} from '../../constants/routes';

const Main = ({ classes, children, newLandingPage, isLoggedIn, pathName, portalConfig }) => {
  const currentPath = window.location.pathname;
  const isNoAuthNoHeaderPage = NO_AUTH_NO_HEADER_PAGES.includes(currentPath);
  const pathException = ['/admin/console/applications/add',
  '/admin/console/templatecategories/add', '/admin/api-groups/add',
  '/admin/console/users/add', '/admin/apis/api-plans/add'];
  const pathHideBreadCrumb = ['/admin/app/home', '/admin/login', '/admin/app/registration',
  '/admin/app/reset-password', '/admin/app/change-password', '/admin/app/new-password', '/admin/app/check-your-email',
  '/admin/app/guest/dashboard', '/admin/app/account-setup-form', '/admin/app/invalidtoken', '/admin/saml/login/confirm'];
  let isBreadCrumbVisible = includes(pathName, 'edit') || includes(pathName, 'add')
  || includes(pathHideBreadCrumb, pathName);
  isBreadCrumbVisible = includes(pathException, pathName) ? false : isBreadCrumbVisible;

  return (
    <div data-apim-test="main-container">
      {isLoggedIn ?
        <>
          {newLandingPage ? <GlobalHeader /> : <Header />}
        </>
      :
      (!isNoAuthNoHeaderPage && <NonAuthHeader />)}
        <div
          data-apim-test="main-page-content"
          className={isNoAuthNoHeaderPage ? classes.NoHeaderContent : classes.MainPageContent}
        >
          {!isBreadCrumbVisible &&
            <BreadcrumbsForPages pathName={pathName} items={[]} portalConfig={portalConfig} />
          }
          {children}
        </div>
        <CookiePolicyBanner />
    </div>
  );
};
export const mapStateToProps = (state) => ({
  newLandingPage: getNewLandingPage(state),
  pathName: get(state, 'router.location.pathname'),
});
Main.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.object,
  newLandingPage: PropTypes.bool,
  pathName: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  portalConfig: PropTypes.shape({}),
};

export default compose(withStyles(theme), connect(mapStateToProps))(Main);
